"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var isBrandSafe = function (story) {
    return !!(story === null || story === void 0 ? void 0 : story.isBrandSafe);
};
exports.default = isBrandSafe;
